import React, { useState, useEffect, useRef } from "react";
import { Grid, Divider, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { CiCircleCheck } from "react-icons/ci";
import { IoEye, IoEyeOff } from "react-icons/io5";

import CustomInput from "../../Components/CustomInputs/CustomInputs";
import CustomDropDown from "../../Components/DropDown/CustomDropDown";
import {
  GreenColorButton,
  PrimeGrayBorderColorButton,
} from "../../Components/MaterialButtonStyle/StyleButton";
import Header from "../../Components/LandingPage/LandingPageHeader";
import CustomCheckBox from "../../Components/CheckBox/CustomCheckBox";
import CustomModal from "../../Components/Modal/CustomModal";
import { PostMethod } from "../../Helper/api";
import { formatDateToISO } from "../../Components/Helpers/DateTimeConverter";
import { encryptData } from "../../Helper/Encryptions";
// import AutoComplete from "../../Components/GoogleAutoComplete/AutoComplete";
import {
  NigeriaStatesInfo,
  LocalGovernmentAreaInfo,
} from "../../Components/Templates/DataFile/Data";
const NewUserRegistration = () => {
  const [ninNumber, setNinNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [Userpic, setUserpic] = useState("");
  // const [Userpic1, setUserpic1] = useState("");

  const navigate = useNavigate();
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const length = 6;
  const [loaders, setloaders] = useState(false);
  const [NewWeak, setNewWeak] = useState(false);
  const [NewMedium, setNewMedium] = useState(false);
  const [NewStrong, setNewStrong] = useState(false);
  const [ConfirmWeak, setConfirmWeak] = useState(false);
  const [ConfirmMedium, setConfirmMedium] = useState(false);
  const [ConfirmStrong, setConfirmStrong] = useState(false);
  const [ninNumberStatus, setNinNumberStatus] = useState(true);
  const [confimation, setConfimation] = useState(false);
  const [stateconfimation, setstateconfimation] = useState(false);

  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [isTimerActive, setIsTimerActive] = useState(false);
  const inputRefs = useRef([]);
  const [otpNumber, setOtpNumber] = useState("");
  const [otptimer, setOTPTimer] = useState(60);
  const [otpModal, setOTPModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [ipaddress, setipaddress] = useState("");

  const [first_name, setfirstname] = useState("");
  const [last_name, setlastname] = useState("");
  const [father_name, setfathername] = useState("");
  const [gender, setgender] = useState("");
  const [dob, setdob] = useState("");
  const [state, setstate] = useState("");
  const [local_area, setlocalarea] = useState("");
  const [LocalAreas, setLocalAreas] = useState([]);
  const [newemail, setnewemail] = useState("");
  const [ninID, setninID] = useState("");
  const [maritalStatus, setmaritalStatus] = useState("");
  const [spokenLanguage, setspokenLanguage] = useState("");

  const [Residentialaddeess, setResidentialaddeess] = useState("");
  const [Mandatory, setMandatory] = useState({
    FistName: false,
    LastName: false,
    MiddleName: false,
    Gender: false,
    DOB: false,
    StateOfOrgine: false,
    LGA: false,
    Email: false,
    Address: false,
  });

  const GenderDetails = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  const strongRegex =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&,[\]){}}(^+{#}=_-]{8,}$/;
  const mediumRegex =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*?&,[\]({)}^+{#}=_-]{6,}$/;

  useEffect(() => {
    GetIpaddress();
  }, []);

  const GetIpaddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org/");
      const data = await response.text();
      setipaddress(data);
    } catch (Error) {
      console.log("Error GetIpaddress", Error);
    }
  };
  const HandleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const RegiterationSubmit = (e) => {
    e.preventDefault();
  };
  const handleToggleVisibility = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };
  const handleChange = (field, value) => {
    setPasswords((prev) => ({ ...prev, [field]: value }));
  };
  const HandleNewPassword = () => {
    if (passwords.newPassword.trim().length > 0) {
      setNewWeak(true);
    }
    if (mediumRegex.test(passwords.newPassword)) {
      setNewMedium(true);
    }
    if (!mediumRegex.test(passwords.newPassword)) {
      setNewMedium(false);
    }
    if (strongRegex.test(passwords.newPassword)) {
      setNewStrong(true);
    }
    if (!strongRegex.test(passwords.newPassword)) {
      setNewStrong(false);
    }
  };
  const HandleConfirmPassword = () => {
    if (passwords.confirmPassword.trim().length > 0) {
      setConfirmWeak(true);
    }
    if (mediumRegex.test(passwords.confirmPassword)) {
      setConfirmMedium(true);
    }
    if (!mediumRegex.test(passwords.confirmPassword)) {
      setConfirmMedium(false);
    }
    if (strongRegex.test(passwords.confirmPassword)) {
      setConfirmStrong(true);
    }
    if (!strongRegex.test(passwords.confirmPassword)) {
      setConfirmStrong(false);
    }
  };
  const ValidationEmails = (mail) => {
    /* eslint-disable */
    const regExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(mail);
    /* eslint-enable */
  };
  const ValidatePassword = (password) => {
    var passwordValidation =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return passwordValidation.test(password);
  };
  const HandleValidation = async () => {
    try {
      if (!ninNumber || ninNumber == "") {
        toast.warn("Enter valid NIN Number");
        return;
      }
      if (!phoneNumber) {
        toast.warn("Enter Valid phone Number");
        return;
      }
      if (String(phoneNumber)?.trim().length != 10) {
        toast.warn("Enter Valid phone Number");
        return;
      }
      if (!passwords.newPassword) {
        toast.warn("Password Field Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.newPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character",
        );
        return;
      }
      if (!passwords.confirmPassword) {
        toast.warn("Confirm Password Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.confirmPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character",
        );
        return;
      }
      if (passwords.newPassword !== passwords.confirmPassword) {
        toast.warn("Passwords Mismatched");
        return;
      }
      let url = "candidate/checknni";
      let method = "POST";
      let params = {
        niu: ninNumber,
      };
      setloaders(true);
      const response = await PostMethod({ url, method, params });

      if (response.status) {
        setloaders(false);
        let results = response.result;
        let firstname,
          lastname,
          gender,
          middlename,
          State,
          lga,
          Address,
          Email,
          DOB = false;
        if (results.first_name && results.first_name != "") {
          setfirstname(results.first_name);
          firstname = true;
        }
        if (results.last_name && results.last_name != "") {
          setlastname(results.last_name);
          lastname = true;
        }
        if (results.gender && results.gender != "") {
          setgender(results.gender);
          gender = true;
        }
        if (results.middlename && results.middlename != "") {
          setfathername(results.middlename);
          middlename = true;
        }
        if (results.state && results.state != "") {
          setstate(results.state);
          State = true;
        }
        if (results.lga && results.lga != "") {
          setlocalarea(results.lga);
          lga = true;
        }
        if (results.locations && results.locations != "") {
          setResidentialaddeess({ Address: results.locations });
          Address = true;
        }
        if (results.email && results.email != "") {
          Email = true;
        }
        if (results.dob) {
          DOB = true;
          if (String(results.dob).length <= 10) {
            let DOB = Number(results.dob) * 1000;
            setdob(DOB);
          } else {
            setdob(results.dob);
          }
        }
        setMandatory({
          FistName: firstname,
          LastName: lastname,
          MiddleName: middlename,
          Gender: gender,
          DOB: DOB,
          StateOfOrgine: State,
          LGA: lga,
          Email: Email,
          Address: Address,
        });
        setUserpic(results.images);

        if (results.phoneNumber) {
          setPhoneNumber(results.phoneNumber);
        }

        if (results.image) {
          // setUserpic1(results.image)
        }
        setnewemail(results.email);

        setNinNumberStatus(true);
        setninID(results.nin_uuid);
        setmaritalStatus(results.maritalStatus);
        setspokenLanguage(results.spokenLanguage);
      } else {
        if (response.message) {
          toast.error(response.message);
        } else {
          toast.error("Something went wrong , please try again later");
        }

        setloaders(false);
      }
    } catch (Error) {
      toast.error("Something went wrong , please try again later");
      setloaders(false);
      console.log("err in HandleValidation", Error);
    }
  };
  const HandleClearIuputs = () => {
    setNinNumber("");
    setPhoneNumber("");
    setPasswords({ newPassword: "", confirmPassword: "" });
  };
  // const HandleBackNavigation = () => {
  //   if (ninNumberStatus) {
  //     setNinNumberStatus(false);
  //   }else {
  //     HandleClearIuputs();
  //     navigate(-1);
  //   }
  // }
  const validateField = (value, message) => {
    if (!value || String(value).trim().length === 0) {
      toast.warn(message);
      return false;
    }
    return true;
  };
  const HandleAutoDetailsValidation = async () => {
    setlocalarea(Residentialaddeess.Address);

    try {
      if (!validateField(first_name, "Enter Valid First name")) return;
      if (!validateField(last_name, "Enter Valid Last name")) return;
      if (!validateField(gender, "Please Select the gender")) return;
      if (!validateField(dob, "Please Select the DOB")) return;
      if (!validateField(state, "Please Select the state")) return;
      if (!validateField(local_area, "Please Select the local Government Area"))
        return;
      if (!newemail) {
        toast.warn("Enter Valid Email");
        return;
      }
      if (!ValidationEmails(newemail)) {
        toast.warn("Invalid Email Entered");
        return;
      }
      if (!Residentialaddeess) {
        toast.warn("Invalid Address Entered");
        return;
      }
      if (!phoneNumber) {
        toast.warn("Enter Valid phone Number");
        return;
      }
      if (String(phoneNumber)?.trim().length != 10) {
        toast.warn("Enter Valid phone Number");
        return;
      }
      if (!ninNumber || ninNumber == "") {
        toast.warn("Enter valid NIN Number");
        return;
      }
      if(String(ninNumber)?.trim().length != 11){
        toast.warn("Enter valid NIN Number");
        return;
      }
      if (!passwords.newPassword) {
        toast.warn("Password Field Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.newPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character",
        );
        return;
      }
      if (!passwords.confirmPassword) {
        toast.warn("Confirm Password Can't Be Empty");
        return;
      }
      if (!ValidatePassword(passwords.confirmPassword)) {
        toast.warn(
          "Password must be 8 characters long , Must have 1 capital letter atleast, One Number And One Special Character",
        );
        return;
      }
      if (passwords.newPassword !== passwords.confirmPassword) {
        toast.warn("Passwords Mismatched");
        return;
      }

      if (!validateField(Residentialaddeess?.Address, "Enter valid address"))
        return;
      if (confimation == false) {
        toast.warn("Select the Confirmation Check Box");
        return;
      }
      if (stateconfimation == false) {
        toast.warn("Select the Confirmation Check Box");
        return;
      }

      let url = "candidate/register";
      let method = "POST";
      let params = {
        nin: encryptData(ninNumber),
        email: encryptData(newemail),
        mobile_number: encryptData(phoneNumber),
        password: encryptData(passwords.newPassword),
        first_name: encryptData(first_name),
        last_name: encryptData(last_name),
        gender: encryptData(gender),
        dob: dob,
        state: encryptData(state),
        ipaddress: "192.168.0.1",
        city: encryptData(local_area),
        address: encryptData(Residentialaddeess?.Address),
        maritalStatus: maritalStatus,
        spokenLanguage: spokenLanguage,
        candidate_image: Userpic,
      };

      setloaders(true);
      const response = await PostMethod({ url, method, params });
      if (response.status) {
        setloaders(false);
        setOTPTimer(60);
        setOTPModal(true);
      } else {
        setloaders(false);
        toast.error(response.message);
      }
    } catch (Error) {
      setloaders(false);
      toast.error("Something went wrong, try again later");
      console.log("Error in HandleAutoDetailsValidation", Error);
    }
  };
  const HandleChangeOTP = (value, index) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }
    setOtpNumber(newOtp.join(""));
  };
  const HandleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const HandlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, length);
    const newOtp = otp.map((_, idx) => pasteData[idx] || "");
    setOtp(newOtp);
    const nextFocusIndex =
      pasteData.length < length ? pasteData.length : length - 1;
    inputRefs.current[nextFocusIndex]?.focus();
    setOtpNumber(newOtp.join(""));
  };
  const HandleRequestOTP = () => {
    setIsTimerActive(true);
    setOTPTimer(60);
  };
  const OtpValidation = async () => {
    try {
      if (otpNumber == "") {
        toast.warn("Please enter valid OTP number");
        return;
      }
      if (otpNumber.length != 6) {
        toast.warn("OTP must be 6 digit number");
        return;
      }
      let url = "candidate/verifyotp";
      let method = "POST";
      let params = {
        nin: encryptData(ninID),
        email: encryptData(newemail),
        otp: otpNumber,
        ipaddress: ipaddress,
      };
      const response = await PostMethod({ url, method, params });

      if (response.status) {
        let data = response.result;
        let users = response.result.user;
        let userdata = {
          first_name: users.candidate_first_name,
          last_name: users.candidate_last_name,
          email: users.candidate_email,
          role: data.roles,
          image: users.candidate_image,
        };
        let user = JSON.stringify(userdata);
        let usersroles = "applicant";
        localStorage.setItem("@users", user);
        localStorage.setItem("islogedin", "true");
        localStorage.setItem("@userType", usersroles);
        localStorage.setItem("@accesstoken", data.accessToken);
        localStorage.setItem("@userid", users.candidate_uuid);
        setOTPModal(false);
        setSuccessModal(true);
      } else {
        toast.error(response.message);
      }
    } catch (Error) {
      toast.error("Something went wrong, please try again");
      console.log("err in OtpValidation", Error);
    }
  };
  const ResendOtp = () => {
    try {
      HandleRequestOTP();
      toast.success("Resend OTP send successfully");
    } catch (err) {
      console.log("err in ResendOtp", err);
    }
  };
  const HandleApplicantDashboard = () => {
    navigate("/");
    window.location.reload();
  };
  const HandleNavigates = () => {
    setNinNumberStatus(false);
    HandleClearIuputs();
    navigate(-1);
  };
  const CloseModal = () => {
    setOtp(new Array(length).fill(""));
    setOtpNumber("");
    setOTPModal(false);
    HandleNavigates();
  };
  useEffect(() => {
    HandleNewPassword(passwords.newPassword);
    HandleConfirmPassword(passwords.confirmPassword);
    if (otptimer < 0) {
      setIsTimerActive(false);
    } else {
      setIsTimerActive(true);
    }
    const intervalId = setInterval(() => {
      setOTPTimer((prevSeconds) => prevSeconds - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [passwords.newPassword, passwords.confirmPassword, otptimer]);
  const HandleDates = async (value) => {
    if (value) {
      let date = new Date(value).getTime();
      setdob(date);
    }
  };
  const HandleSeletedState = (values) => {
    const FillterData = LocalGovernmentAreaInfo.filter(
      (item) =>
        String(item.state).toLowerCase() == String(values).toLowerCase(),
    );
    setLocalAreas(FillterData);
    setstate(values);
  };
  return (
    <Grid item container lg={12} className="loginbgbanner">
      <Header />
      <Grid
        item
        container
        justifyContent={"center"}
        alignItems={"center"}
        padding={4}
      >
        <Grid
          item
          container
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="bg-white borderRadius12 p-4 CustomScroll"
        >
          <h4
            role="presentation"
            className="poppinsMedium Text-Prime-Black  text-left pt-3 pointer"
            // onClick={HandleBackNavigation}
          >
            {/* <IoArrowBackOutline color={"#222222"} size={24} className="mr-2" />  */}
            New User Registration
          </h4>
          <Divider
            className="mt-3 w-100"
            sx={{ border: "1px solid #0FBE7C" }}
          />
          <p className="poppinsMedium Text-Prime-Black pt-3 text-left">
            {ninNumberStatus
              ? "Please Review and Check your Data from NIN Database."
              : "Please Provide Required Informations Below to Continue"}
          </p>
          {ninNumberStatus == false ? (
            <>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                flexDirection={"column"}
                className="CustomScroll pr-2"
                sx={{ height: "50vh", overflow: "scroll" }}
              >
                <form
                  style={{ width: "100%", display: "contents" }}
                  className="loginregister"
                  onSubmit={RegiterationSubmit}
                >
                  {/* <Grid container>
                  <p className=" poppinsMedium Text-Prime-Black pt-3">
                    NIN Number
                  </p>
                  <CustomInput
                    placeholderColor={"#666666"}
                    placeholder="Enter NIN Number"
                    padding={"2% 2% 2% 0%"}
                    border={"1px solid  #666666"}
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    maxLength={100}
                    marginTop={"1%"}
                 
                    value={ninNumber}
                    onChange={(e) => setNinNumber(e.target.value)}
                  />
                </Grid> */}

                  <Grid item container>
                    <p className="Text-Prime-Black poppinsMedium pt-3 text-left">
                      Phone Number
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      placeholder="Enter Your Phone Number (ex:+234 XX XXXX XXXX)"
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      padding={"2%"}
                      marginTop={"1%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      maxLength={10}
                      type="number"
                      InputFrontProps={
                        <p
                          className="Text-Prime-Black poppinsMedium pr-2"
                          style={{ wordBreak: "unset" }}
                        >
                          +234
                        </p>
                      }
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </Grid>
                  <Grid container>
                    <p className=" poppinsMedium Text-Prime-Black pt-3">
                      Password
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      placeholder="Enter Your Password"
                      type={showPassword.newPassword ? "text" : "password"}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={50}
                      marginTop={"1%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      value={passwords.newPassword}
                      InputProps={
                        showPassword.newPassword ? (
                          <IoEye
                            className="eyeIcons pointer"
                            onClick={() =>
                              handleToggleVisibility("newPassword")
                            }
                            onMouseDown={HandleMouseDownPassword}
                            color="#222222"
                            size={22}
                          />
                        ) : (
                          <IoEyeOff
                            className="eyeIcons pointer"
                            onClick={() =>
                              handleToggleVisibility("newPassword")
                            }
                            onMouseDown={HandleMouseDownPassword}
                            color="#222222"
                            size={22}
                          />
                        )
                      }
                      onChange={(e) =>
                        handleChange("newPassword", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid
                    container
                    lg={12}
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    className="mt-2"
                  >
                    <Grid
                      item
                      lg={3.5}
                      md={3.5}
                      sm={3.5}
                      xs={3.5}
                      height={"30px"}
                    >
                      <Grid
                        container
                        lg={12}
                        className="p-1 rounded"
                        sx={{
                          backgroundColor: !NewWeak ? "#E0E0E0" : "#E62A4A",
                        }}
                      ></Grid>
                      {NewWeak && (
                        <p
                          className="text-center mt-1 poppinsRegular fontSize12"
                          style={{ color: "#E62A4A" }}
                        >
                          {" "}
                          Weak
                        </p>
                      )}
                    </Grid>
                    <Grid
                      item
                      lg={3.5}
                      md={3.5}
                      sm={3.5}
                      xs={3.5}
                      height={"30px"}
                    >
                      <Grid
                        container
                        lg={12}
                        className="p-1 rounded"
                        sx={{
                          backgroundColor: !NewMedium ? "#E0E0E0" : "#E9B229",
                        }}
                      ></Grid>
                      {NewMedium && (
                        <p
                          className="text-center mt-1 poppinsRegular fontSize12"
                          style={{ color: "#E9B229" }}
                        >
                          {" "}
                          Medium
                        </p>
                      )}
                    </Grid>
                    <Grid
                      item
                      lg={3.5}
                      md={3.5}
                      sm={3.5}
                      xs={3.5}
                      height={"30px"}
                    >
                      <Grid
                        container
                        lg={12}
                        className="p-1 rounded"
                        sx={{
                          backgroundColor: !NewStrong ? "#E0E0E0" : "#52BD94",
                        }}
                      ></Grid>
                      {NewStrong && (
                        <p
                          className="text-center mt-1 poppinsRegular fontSize12"
                          style={{ color: "#52BD94" }}
                        >
                          {" "}
                          Strong
                        </p>
                      )}
                    </Grid>
                  </Grid>
                  <Grid container>
                    <p className=" poppinsMedium Text-Prime-Black">
                      Confirm Password
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      placeholder="Enter Your Confirm Password"
                      type={showPassword.confirmPassword ? "text" : "password"}
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      maxLength={50}
                      marginTop={"1%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      value={passwords.confirmPassword}
                      InputProps={
                        showPassword.confirmPassword ? (
                          <IoEye
                            className="eyeIcons pointer"
                            onClick={() =>
                              handleToggleVisibility("confirmPassword")
                            }
                            onMouseDown={HandleMouseDownPassword}
                            color="#222222"
                            size={22}
                          />
                        ) : (
                          <IoEyeOff
                            className="eyeIcons pointer"
                            onClick={() =>
                              handleToggleVisibility("confirmPassword")
                            }
                            onMouseDown={HandleMouseDownPassword}
                            color="#222222"
                            size={22}
                          />
                        )
                      }
                      onChange={(e) =>
                        handleChange("confirmPassword", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid
                    container
                    lg={12}
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    className="mt-2"
                  >
                    <Grid
                      item
                      lg={3.5}
                      md={3.5}
                      sm={3.5}
                      xs={3.5}
                      height={"30px"}
                    >
                      <Grid
                        container
                        lg={12}
                        className="p-1 rounded"
                        sx={{
                          backgroundColor: !ConfirmWeak ? "#E0E0E0" : "#E62A4A",
                        }}
                      ></Grid>
                      {ConfirmWeak && (
                        <p
                          className="text-center mt-1 poppinsRegular fontSize12"
                          style={{ color: "#E62A4A" }}
                        >
                          {" "}
                          Weak
                        </p>
                      )}
                    </Grid>
                    <Grid
                      item
                      lg={3.5}
                      md={3.5}
                      sm={3.5}
                      xs={3.5}
                      height={"30px"}
                    >
                      <Grid
                        container
                        lg={12}
                        className="p-1 rounded"
                        sx={{
                          backgroundColor: !ConfirmMedium
                            ? "#E0E0E0"
                            : "#E9B229",
                        }}
                      ></Grid>
                      {ConfirmMedium && (
                        <p
                          className="text-center mt-1 poppinsRegular fontSize12"
                          style={{ color: "#E9B229" }}
                        >
                          {" "}
                          Medium
                        </p>
                      )}
                    </Grid>
                    <Grid
                      item
                      lg={3.5}
                      md={3.5}
                      sm={3.5}
                      xs={3.5}
                      height={"30px"}
                    >
                      <Grid
                        container
                        lg={12}
                        className="p-1 rounded"
                        sx={{
                          backgroundColor: !ConfirmStrong
                            ? "#E0E0E0"
                            : "#52BD94",
                        }}
                      ></Grid>
                      {ConfirmStrong && (
                        <p
                          className="text-center mt-1 poppinsRegular fontSize12"
                          style={{ color: "#52BD94" }}
                        >
                          {" "}
                          Strong
                        </p>
                      )}
                    </Grid>
                  </Grid>
                  <p className="poppinsRegular Text-Prime-Red fontSize14 pt-3 text-center">
                    To apply for the Nigerian Police Force (NPF), you are
                    required to provide your National Identification Number
                    (NIN).{" "}
                  </p>
                  <p className="poppinsRegular Text-Prime-Red fontSize14 pt-3 text-center">
                    By entering your NIN, you authorise the NPF to access your
                    bio data for verification purposes. Your profile will be
                    validated on this page before you can proceed to the
                    application form.
                  </p>
                  <p className="poppinsRegular Text-Prime-Red fontSize14 pt-3 text-center">
                    i.e. Your profile will be validated on this page before you
                    can proceed to the application form.
                  </p>
                </form>
              </Grid>
              <Grid item container justifyContent={"center"}>
                <GreenColorButton
                  type="submit"
                  className="px-5 py-2"
                  disabled={loaders}
                  onClick={() => HandleValidation()}
                >
                  {!loaders ? (
                    <h4>Verify</h4>
                  ) : (
                    <CircularProgress size="2rem" style={{ color: "#fff" }} />
                  )}
                </GreenColorButton>
              </Grid>
            </>
          ) : (
            <>
              <Grid
                item
                container
                lg={12}
                className="CustomScroll pr-2"
                sx={{ height: "50vh", overflow: "scroll" }}
              >
                <h5 className="poppinsSemiBold Text-Prime-Black pt-3 text-left">
                  Basic Details
                </h5>
                <Divider
                  className="mt-2 w-100"
                  sx={{ border: "1px solid #a7aba96e" }}
                />
                {/* <Grid item container lg={12} justifyContent={"center"} className="pt-3">
                <Grid item container lg={3.5} overflow={"hidden"} justifyContent={"center"} alignItems={"center"}>
                  <img src={Userpic1} className="img-fluid" alt="profile-pic" />
                </Grid>
              </Grid> */}
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"space-between"}
                  className="mt-3"
                >
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      First Name <span className="Text-Prime-Red">*</span>
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      backgroundColor={Mandatory.LastName ? "#EEECEC" : ""}
                      width={"100%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter First Name"
                      maxLength={100}
                      value={first_name}
                      disabled={Mandatory.FistName}
                      onChange={(e) => setfirstname(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Last Name <span className="Text-Prime-Red">*</span>
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      backgroundColor={Mandatory.LastName ? "#EEECEC" : ""}
                      width={"100%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter Last Name"
                      maxLength={100}
                      value={last_name}
                      disabled={Mandatory.LastName}
                      onChange={(e) => setlastname(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"space-between"}
                  className="mt-3"
                >
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Middle Name 
                      {/* <span className="Text-Prime-Red">*</span> */}
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      backgroundColor={Mandatory.MiddleName ? "#EEECEC" : ""}
                      width={"100%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter Middle Name"
                      maxLength={100}
                      value={father_name}
                      disabled={Mandatory.MiddleName}
                      onChange={(e) => setfathername(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Gender <span className="Text-Prime-Red">*</span>
                    </p>
                    {Mandatory.Gender ? (
                      <CustomInput
                        placeholderColor={"#666666"}
                        backgroundColor="#EEECEC"
                        width={"100%"}
                        padding={"2% 2% 2% 0%"}
                        border={"1px solid  #666666"}
                        fontFamily={"PoppinsMedium"}
                        placeholder="Enter Gender"
                        maxLength={10}
                        value={gender}
                        disabled={Mandatory.Gender}
                      />
                    ) : (
                      <CustomDropDown
                        data={GenderDetails}
                        placeholder={"Select your gender"}
                        borderRadius={"8px"}
                        backgroundColor="#FFFFFF"
                        selected={gender && { label: gender, value: gender }}
                        onChange={(e) => setgender(e.value)}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"space-between"}
                  className="mt-3"
                >
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Date of Birth <span className="Text-Prime-Red">*</span>
                    </p>
                    <CustomInput
                      // placeholderColor={"#666666"}
                      // backgroundColor="#EEECEC"
                      disableFutureDates={true}
                      width={"100%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter Date of Birth"
                      maxLength={20}
                      type={"date"}
                      value={formatDateToISO(dob)}
                      onChange={(e) => HandleDates(e.target.value)}
                      disabled={Mandatory.DOB}
                    />
                  </Grid>
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      State of Origin <span className="Text-Prime-Red">*</span>
                    </p>
                    {Mandatory.StateOfOrgine ? (
                      <CustomInput
                        placeholderColor={"#666666"}
                        backgroundColor="#EEECEC"
                        width={"100%"}
                        padding={"2% 2% 2% 0%"}
                        border={"1px solid  #666666"}
                        fontFamily={"PoppinsMedium"}
                        placeholder="Select State"
                        maxLength={100}
                        value={state}
                        disabled={Mandatory.StateOfOrgine}
                      />
                    ) : (
                      <CustomDropDown
                        data={NigeriaStatesInfo}
                        placeholder={"Select your State"}
                        borderRadius={"8px"}
                        backgroundColor="#FFFFFF"
                        selected={state && { label: state, value: state }}
                        onChange={(e) => HandleSeletedState(e.value)}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"space-between"}
                  className="mt-3"
                >
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Local Government Area <span className="Text-Prime-Red">*</span>
                    </p>

                    {Mandatory.LGA ? (
                      <CustomInput
                        placeholderColor={"#666666"}
                        backgroundColor="#EEECEC"
                        width={"100%"}
                        padding={"2% 2% 2% 0%"}
                        border={"1px solid  #666666"}
                        fontFamily={"PoppinsMedium"}
                        placeholder="Enter Local Government Area"
                        maxLength={100}
                        value={local_area}
                        disabled={Mandatory.StateOfOrgine}
                      />
                    ) : (
                      <CustomDropDown
                        data={LocalAreas}
                        placeholder={"Select your Local Government Area"}
                        borderRadius={"8px"}
                        backgroundColor="#FFFFFF"
                        selected={
                          local_area && { label: local_area, value: local_area }
                        }
                        onChange={(e) => setlocalarea(e.value)}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Email <span className="Text-Prime-Red">*</span>
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      backgroundColor={Mandatory.Email ? "#EEECEC" : ""}
                      width={"100%"}
                      padding={"2% 2% 2% 0%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      placeholder="Enter Email"
                      maxLength={100}
                      value={newemail}
                      onChange={(e) => setnewemail(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  xs={12}
                  justifyContent={"space-between"}
                  className="mt-3"
                >
                  <Grid
                    item
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Permanent Home Address <span className="Text-Prime-Red">*</span>
                    </p>

                    {/* <AutoComplete
                      placeholder={"Enter Permanent Home Address"}
                      Location={Residentialaddeess?.Address}
                      setLocation={(e) => setResidentialaddeess(e)}
                      height={"35px"}
                    /> */}
                    <CustomInput
                      placeholderColor={"#666666"}
                      placeholder="Enter Permanent Home Address"
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      padding={"2% 2% 2% 0%"}
                      // padding={"2%"}
                      // height={"35px"}
                      marginTop={"1%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      maxLength={250}
                      type="text"
                      value={Residentialaddeess?.Address}
                      onChange={(e) => setResidentialaddeess({
                        ...Residentialaddeess,
                        Address: e.target.value,
                      })}
                    />
                  </Grid>
                  {/* <Grid
                    item
                    container
                    lg={5.8}
                    md={5.8}
                    sm={12}
                    xs={12}
                    flexDirection={"column"}
                  ></Grid> */}
               
                  <Grid item  lg={5.8} md={5.8} sm={12} xs={12}
                    display={"flex"}
                    flexDirection={"column"}>
                    <p className="Text-Prime-Black poppinsMedium pb-1 text-left">
                      Phone Number <span className="Text-Prime-Red">*</span>
                    </p>
                    <CustomInput
                      placeholderColor={"#666666"}
                      placeholder="Enter Your Phone Number (ex:+234 XX XXXX XXXX)"
                      backgroundColor="#FFFFFF"
                      width={"100%"}
                      // padding={"2%"}
                      // height={"35px"}
                      marginTop={"1%"}
                      border={"1px solid  #666666"}
                      fontFamily={"PoppinsMedium"}
                      maxLength={10}
                      type="number"
                      InputFrontProps={
                        <p
                          className="Text-Prime-Black poppinsMedium pr-2"
                          style={{ wordBreak: "unset" }}
                        >
                          +234
                        </p>
                      }
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <p className=" poppinsMedium Text-Prime-Black pt-3">
                    NIN Number <span className="Text-Prime-Red">*</span>
                  </p>
                  <CustomInput
                    placeholderColor={"#666666"}
                    placeholder="Enter NIN Number"
                    padding={"2% 2% 2% 0%"}
                    type={"number"}
                    border={"1px solid  #666666"}
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    maxLength={11}
                    marginTop={"1%"}
                    value={ninNumber}
                    onChange={(e) => setNinNumber(e.target.value)}
                  />
                </Grid>
                <Grid container>
                  <p className=" poppinsMedium Text-Prime-Black pt-3">
                    Password <span className="Text-Prime-Red">*</span>
                  </p>
                  <CustomInput
                    placeholderColor={"#666666"}
                    placeholder="Enter Your Password"
                    type={showPassword.newPassword ? "text" : "password"}
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    maxLength={50}
                    marginTop={"1%"}
                    padding={"2% 2% 2% 0%"}
                    border={"1px solid  #666666"}
                    value={passwords.newPassword}
                    InputProps={
                      showPassword.newPassword ? (
                        <IoEye
                          className="eyeIcons pointer"
                          onClick={() => handleToggleVisibility("newPassword")}
                          onMouseDown={HandleMouseDownPassword}
                          color="#222222"
                          size={22}
                        />
                      ) : (
                        <IoEyeOff
                          className="eyeIcons pointer"
                          onClick={() => handleToggleVisibility("newPassword")}
                          onMouseDown={HandleMouseDownPassword}
                          color="#222222"
                          size={22}
                        />
                      )
                    }
                    onChange={(e) =>
                      handleChange("newPassword", e.target.value)
                    }
                  />
                </Grid>
                <Grid
                  container
                  lg={12}
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  className="mt-2"
                >
                  <Grid
                    item
                    lg={3.5}
                    md={3.5}
                    sm={3.5}
                    xs={3.5}
                    height={"30px"}
                  >
                    <Grid
                      container
                      lg={12}
                      className="p-1 rounded"
                      sx={{
                        backgroundColor: !NewWeak ? "#E0E0E0" : "#E62A4A",
                      }}
                    ></Grid>
                    {NewWeak && (
                      <p
                        className="text-center mt-1 poppinsRegular fontSize12"
                        style={{ color: "#E62A4A" }}
                      >
                        {" "}
                        Weak
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    lg={3.5}
                    md={3.5}
                    sm={3.5}
                    xs={3.5}
                    height={"30px"}
                  >
                    <Grid
                      container
                      lg={12}
                      className="p-1 rounded"
                      sx={{
                        backgroundColor: !NewMedium ? "#E0E0E0" : "#E9B229",
                      }}
                    ></Grid>
                    {NewMedium && (
                      <p
                        className="text-center mt-1 poppinsRegular fontSize12"
                        style={{ color: "#E9B229" }}
                      >
                        {" "}
                        Medium
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    lg={3.5}
                    md={3.5}
                    sm={3.5}
                    xs={3.5}
                    height={"30px"}
                  >
                    <Grid
                      container
                      lg={12}
                      className="p-1 rounded"
                      sx={{
                        backgroundColor: !NewStrong ? "#E0E0E0" : "#52BD94",
                      }}
                    ></Grid>
                    {NewStrong && (
                      <p
                        className="text-center mt-1 poppinsRegular fontSize12"
                        style={{ color: "#52BD94" }}
                      >
                        {" "}
                        Strong
                      </p>
                    )}
                  </Grid>
                </Grid>
                <Grid container>
                  <p className=" poppinsMedium Text-Prime-Black">
                    Confirm Password <span className="Text-Prime-Red">*</span>
                  </p>
                  <CustomInput
                    placeholderColor={"#666666"}
                    placeholder="Enter Your Confirm Password"
                    type={showPassword.confirmPassword ? "text" : "password"}
                    backgroundColor="#FFFFFF"
                    width={"100%"}
                    maxLength={50}
                    marginTop={"1%"}
                    padding={"2% 2% 2% 0%"}
                    border={"1px solid  #666666"}
                    value={passwords.confirmPassword}
                    InputProps={
                      showPassword.confirmPassword ? (
                        <IoEye
                          className="eyeIcons pointer"
                          onClick={() =>
                            handleToggleVisibility("confirmPassword")
                          }
                          onMouseDown={HandleMouseDownPassword}
                          color="#222222"
                          size={22}
                        />
                      ) : (
                        <IoEyeOff
                          className="eyeIcons pointer"
                          onClick={() =>
                            handleToggleVisibility("confirmPassword")
                          }
                          onMouseDown={HandleMouseDownPassword}
                          color="#222222"
                          size={22}
                        />
                      )
                    }
                    onChange={(e) =>
                      handleChange("confirmPassword", e.target.value)
                    }
                  />
                </Grid>
                <Grid
                  container
                  lg={12}
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  className="mt-2"
                >
                  <Grid
                    item
                    lg={3.5}
                    md={3.5}
                    sm={3.5}
                    xs={3.5}
                    height={"30px"}
                  >
                    <Grid
                      container
                      lg={12}
                      className="p-1 rounded"
                      sx={{
                        backgroundColor: !ConfirmWeak ? "#E0E0E0" : "#E62A4A",
                      }}
                    ></Grid>
                    {ConfirmWeak && (
                      <p
                        className="text-center mt-1 poppinsRegular fontSize12"
                        style={{ color: "#E62A4A" }}
                      >
                        {" "}
                        Weak
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    lg={3.5}
                    md={3.5}
                    sm={3.5}
                    xs={3.5}
                    height={"30px"}
                  >
                    <Grid
                      container
                      lg={12}
                      className="p-1 rounded"
                      sx={{
                        backgroundColor: !ConfirmMedium ? "#E0E0E0" : "#E9B229",
                      }}
                    ></Grid>
                    {ConfirmMedium && (
                      <p
                        className="text-center mt-1 poppinsRegular fontSize12"
                        style={{ color: "#E9B229" }}
                      >
                        {" "}
                        Medium
                      </p>
                    )}
                  </Grid>
                  <Grid
                    item
                    lg={3.5}
                    md={3.5}
                    sm={3.5}
                    xs={3.5}
                    height={"30px"}
                  >
                    <Grid
                      container
                      lg={12}
                      className="p-1 rounded"
                      sx={{
                        backgroundColor: !ConfirmStrong ? "#E0E0E0" : "#52BD94",
                      }}
                    ></Grid>
                    {ConfirmStrong && (
                      <p
                        className="text-center mt-1 poppinsRegular fontSize12"
                        style={{ color: "#52BD94" }}
                      >
                        {" "}
                        Strong
                      </p>
                    )}
                  </Grid>
                </Grid>
                <p className="poppinsRegular Text-Prime-Red fontSize14 pt-3 text-center">
                  To apply for the Nigerian Police Force (NPF), you are required
                  to provide your National Identification Number (NIN).{" "}
                </p>
                <p className="poppinsRegular Text-Prime-Red fontSize14 pt-3 text-center">
                  By entering your NIN, you authorise the NPF to access your bio
                  data for verification purposes. Your profile will be validated
                  on this page before you can proceed to the application form.
                </p>
                <p className="poppinsRegular Text-Prime-Red fontSize14 pt-3 text-center">
                  i.e. Your profile will be validated on this page before you
                  can proceed to the application form.
                </p>

                <Grid
                  item
                  container
                  lg={12}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  className="mt-3 mb-2"
                >
                  <CustomCheckBox
                    disableColor={"transparent"}
                    checked={confimation}
                    onChange={() => setConfimation(!confimation)}
                  />
                  <Grid item container lg={11}>
                    <p className="poppinsRegular Text-Prime-Gray text-left">
                      I confirm that I have reviewed my bio data, including my
                      NIN, and I fully understand the information provided. I
                      agree to proceed with the registration.
                    </p>
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  lg={12}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  className="mt-3 mb-2"
                >
                  <CustomCheckBox
                    disableColor={"transparent"}
                    checked={stateconfimation}
                    onChange={() => setstateconfimation(!stateconfimation)}
                  />
                  <Grid item container lg={11}>
                    <p className="poppinsRegular Text-Prime-Gray text-left">
                      I acknowledge and agree that the selected Local Government Area and Gender are final and cannot be modified after registration.
                    </p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container justifyContent={"center"} className="mt-3">
                <GreenColorButton
                  type="submit"
                  className="px-5 py-2"
                  disabled={loaders}
                  onClick={() => HandleAutoDetailsValidation()}
                >
                  <h4>Register</h4>
                </GreenColorButton>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
      <CustomModal
        open={otpModal}
        setOpen={setOTPModal}
        divider={false}
        header={true}
        closeIsActive={true}
        CloseModal={CloseModal}
        modalTitle={
          <h4 className="poppinsMedium text-black">Verify Your Email</h4>
        }
        width={window.innerWidth > 600 ? "30%" : "95%"}
        modalContent={
          <Grid
            item
            container
            lg={12}
            md={12}
            sm={12}
            xs={12}
            flexDirection={"column"}
          >
            <p className=" poppinsRegular Text-Prime-Black pt-3 text-left">
              Enter the One Time Password Received to your registered email
              address
            </p>
            <Grid item container justifyContent={"center"}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    type="text"
                    value={digit}
                    onChange={(e) => HandleChangeOTP(e.target.value, index)}
                    onKeyDown={(e) => HandleKeyDown(e, index)}
                    onPaste={HandlePaste}
                    ref={(el) => (inputRefs.current[index] = el)}
                    maxLength={1}
                    style={{
                      width: window.innerWidth > 600 ? "50px" : "40px",
                      height: window.innerWidth > 600 ? "50px" : "40px",
                      textAlign: "center",
                      fontSize: "24px",
                      border: "1px solid #666666",
                      borderRadius: "5px",
                      backgroundColor: "#ffffff",
                      marginTop: "4%",
                      fontFamily: "PoppinsSemiBold",
                    }}
                  />
                ))}
              </div>
              {isTimerActive ? (
                <p className="poppinsRegular Text-Prime-Green pt-3 text-center">
                  Resend OTP in: {otptimer}s
                </p>
              ) : (
                <p
                  role="presentation"
                  className=" poppinsRegular Text-Prime-Green pt-3 pointer text-center"
                  onClick={() => ResendOtp()}
                >
                  Resend OTP
                </p>
              )}
            </Grid>
            <Grid
              item
              container
              display={"flex"}
              justifyContent={"flex-end"}
              sx={{ marginTop: "6%" }}
            >
              <PrimeGrayBorderColorButton
                type="submit"
                className="px-5 py-2"
                sx={{ borderRadius: "4px" }}
                onClick={() => CloseModal()}
              >
                Cancel
              </PrimeGrayBorderColorButton>
              <GreenColorButton
                type="submit"
                className="px-5 py-2 ml-2"
                sx={{ borderRadius: "4px" }}
                onClick={() => OtpValidation()}
              >
                Verify
              </GreenColorButton>
            </Grid>
          </Grid>
        }
      />
      <CustomModal
        open={successModal}
        setOpen={setSuccessModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleCheck color={"#12A59B"} size={80} />
            <p className=" poppinsRegular Text-Prime-Black pt-3 text-center">
              Your account has been successfully verified. You can now log in to
              access your profile
            </p>
            <Grid
              item
              container
              display={"flex"}
              justifyContent={"center"}
              sx={{ marginTop: "6%" }}
            >
              <GreenColorButton
                type="submit"
                className="px-3 py-2"
                onClick={() => HandleApplicantDashboard()}
              >
                Take to Dashboard
              </GreenColorButton>
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
};

export default NewUserRegistration;
